<template>
  <div>
    <div>
      <!-- 初期読み込み時のローディングアイコン -->
      <loading :active.sync="isCreatedLoading" class="post-loading" />

      <!-- モーダルの表示 -->
      <div id="overlay" v-show="!isCreatedLoading">
        <transition appear mode="out-in">
          <div id="content" v-on:click="stopEvent">
            <div>
              <h3>トレーニング情報の共有</h3>
              <div>
                <p class="top-msg-text">
                  ご自身でトレーニングを案内したい場合に以下の内容をコピーしてご利用ください。
                </p>
                <button
                  type="button"
                  v-on:click="copyToClipboard"
                  class="btn btn-primary btn-sm share-msg-copy-btn float-right"
                >
                  <font-awesome-icon icon="copy" class="share-msg-copy-icon" />
                  コピー
                </button>

                <span v-show="isMsgCopy" class="copy-complete-msg float-right">
                  <font-awesome-icon
                    icon="circle-check"
                    class="circle-check-icon"
                  />
                  コピーしました
                </span>
              </div>
              <textarea
                class="form-control announce-text-area"
                v-model="announce_msg"
                rows="20"
                placeholder="（未登録）"
                :disabled="true"
              />
              <button
                style="width: 120px; margin-top: 20px"
                v-on:click="clickEvent"
                class="btn btn-outline-secondary registry-btn share-btn float-right"
                type="button"
              >
                トップへ
              </button>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import { API_BASE_URL } from "@/common/config";
import axios from "axios";

// font awesome
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCheckCircle, faCopy } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faCopy, faCheckCircle);
Vue.component("font-awesome-icon", FontAwesomeIcon);

// vue-loading-overlay
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  props: {
    training_plan_id: String
  },
  name: "training-plan-sharing-modal",
  data() {
    return {
      isCreatedLoading: false,
      announce_msg: "",
      training_id: "",
      training_planning_name: "",
      training_date_from: "",
      training_date_to: "",
      training_coaches: [],
      training_coaches_list: "",
      training_material: "",
      training_place: "",
      training_url: "",
      training_target_person: "",
      training_announce_text: "",
      logger: this.$store.state.logger,
      isMsgCopy: false
    };
  },
  components: { loading: Loading },
  created() {
    this.isCreatedLoading = true;
    //共有対象のトレーニング予定の情報を取得
    let api_url;
    api_url = API_BASE_URL + "training-plannings/" + this.training_plan_id;

    this.logger.debug("Start to get training plan");
    axios
      .get(api_url, {
        headers: {
          Authorization: this.$store.getters.currentUser.idToken.jwtToken
        }
      })
      .then((result) => {
        this.logger.debug(JSON.stringify(result));
        if ("statusCode" in result.data) {
          if (result.data.statusCode == 200) {
            let api_ret = result.data.body;
            this.training_planning_name = api_ret.training_planning_name;
            this.training_id = String(api_ret.training_id);
            this.training_date_from = api_ret.datetime_from;
            this.training_date_to = api_ret.datetime_to.substr(11, 16);
            this.training_material = api_ret.training_material_url;
            this.training_place = api_ret.place;
            this.training_url = api_ret.join_url;
            this.teams_host_user = api_ret.teams_host_name;
            this.training_target_person = api_ret.target_person;
            this.training_announce_text = api_ret.announce_text;

            //講師情報を取得する
            this.training_coaches = api_ret.coaches;

            //取得した講師情報リストにIndexと内部講師フラグを付与する。
            //また、ユーザーIDを数字から文字型に変換する（リストボックスで名前を正しく表示するため）
            for (var i = 0; i < this.training_coaches.length; i++) {
              if (i > 0) {
                this.training_coaches_list = this.training_coaches_list + ", ";
              }
              this.training_coaches_list =
                this.training_coaches_list +
                this.training_coaches[i].coach_name;
            }
            this.logger.debug("end to get training plan");

            // 共有用メッセージの生成
            this.buildSharingMsg();
          } else {
            this.logger.error("API(training plan get) unexpected status error");
            this.logger.error(JSON.stringify(result));
            this.$router.push("/system-error500");
          }
          this.isCreatedLoading = false;
        } else {
          this.logger.error("API(training plan get) unexpected error");
          this.logger.error(JSON.stringify(result));
          this.$router.push("/system-error500");
        }
        // 2つのAPIを非同期で呼び出しているので、
        // 両方完了までローディング中とする
        this.isTrainingInfoGetted = true;
        this.mainLoading = !this.isUserGetted && this.isTrainingInfoGetted;
      })
      .catch((err) => {
        this.mainLoading = false;
        this.logger.error("error in getting training plan");
        this.logger.error(err);
        this.isCreatedLoading = false;
        this.$router.push("/system-error500");
      });
  },
  methods: {
    clickEvent: function () {
      this.$emit("announce-ok");
    },
    stopEvent: function () {
      event.stopPropagation();
    },
    copyToClipboard() {
      navigator.clipboard
        .writeText(this.announce_msg)
        .then(() => {
          console.log("copied!");
          this.isMsgCopy = true;
          setTimeout(this.clearCopyFlag, 2000);
        })
        .catch((e) => {
          console.error(e);
        });
    },
    clearCopyFlag() {
      this.isMsgCopy = false;
    },
    buildSharingMsg() {
      this.announce_msg =
        "以下のトレーニングを登録しましたので奮ってご参加ください。\n\n" +
        "◆基本情報\n" +
        "名称 ：" +
        this.training_planning_name +
        "\n" +
        "日時 ：" +
        this.training_date_from
          .substr(0, 16)
          .replaceAll("T", " ")
          .replaceAll("-", "/") +
        " ～ " +
        this.training_date_to.substr(0, 5) +
        "\n" +
        "講師 ：" +
        this.training_coaches_list +
        "\n" +
        "資料 ：" +
        this.training_material +
        "\n" +
        "会場 ：" +
        this.training_place +
        "\n" +
        "主催者：" +
        this.teams_host_user +
        "\n" +
        "TeamsURL：" +
        this.training_url +
        "\n\n" +
        "◆対象／詳細\n" +
        "対象者：\n" +
        this.training_target_person +
        "\n\n" +
        "詳細：\n" +
        this.training_announce_text +
        "\n\n";
    }
  },

  computed: {
    ...mapGetters(["currentUser"])
  }
};
</script>

<style scoped>
.sharing-msg-box {
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  padding: 15px;
}

.top-msg-text {
  vertical-align: middle;
}

.share-msg-copy-btn {
  margin-left: 10px;
  margin-bottom: 10px;
  width: 100px;
}

.share-msg-copy-icon {
  margin-right: 5px;
  margin-left: 5px;
}

.copy-complete-msg {
  margin-left: 15px;
  color: #adb5bd;
  vertical-align: middle;
}

#content {
  z-index: 10001;
  width: 700px;
  max-width: 90%;
  max-height: 90%;
  padding: 1.5em;
  background: #fff;
  border-radius: 0.75em;
}

.post-loading {
  z-index: 100;
}

#overlay {
  /*　要素を重ねた時の順番　*/
  z-index: 200;

  /*　画面全体を覆う設定　*/
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);

  /*　画面の中央に要素を表示させる設定　*/
  display: flex;
  align-items: center;
  justify-content: center;
}

.announce-text-area {
  /* テキストエリアを広げすぎるとモーダルの縦幅を超える */
  max-height: 45vh;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 1s ease;
}

/* タブレット向け */
@media screen and (min-width: 671px) and (max-width: 1240px) {
  h3 {
    font-size: 1.5em;
  }
}

/* スマホ向け */
@media screen and (max-width: 670px) {
  #content {
    width: 90%;
  }

  h3 {
    font-size: 1.25em;
  }

  .confirmation-top-msg {
    font-size: 1em;
  }

  .btn-action {
    width: 45% !important;
  }

  .announce-text-area {
    height: 300px;
    font-size: 0.9em;
  }
}
</style>
